import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import Definitions from '../../../../../config/codeDefinitions.json';
import './Cell.scss';
import { codeDefinitionsRoute } from '../../../../../config/navigation/routes';

export default class CustomCell extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    tooltip: PropTypes.string,
  };
  static defaultProps = {
    title: '',
    tooltip: '',
  };
  render() {
    const { title, tooltip } = this.props;

    let definitions = {
      AMC: '',
      AMSC: '',
    };
    if (title && title[0]) {
      definitions = {
        AMC: Definitions[title[0]],
        AMSC: Definitions[title[1]],
      };
    }

    if (!title || !title[0]) {
      return null;
    }

    return (
      <React.Fragment>
        <a
          className="nf-cell--link"
          data-tip={tooltip}
          data-for={`tooltip-${title}`}
          href={codeDefinitionsRoute}
        >
          {title}
        </a>
        <ReactTooltip
          id={`tooltip-${title}`}
          type="dark"
          effect="float"
          delayShow={350}
          place="left"
          className="nffs-solicitation-code-definition-tooltip"
        >
          <p>{`AMC ${title[0]}: ${definitions.AMC}`}</p>
          <p>{`AMSC ${title[1]}: ${definitions.AMSC}`}</p>
        </ReactTooltip>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/SolicitationsGrid/subcomponents/CustomCell/Cell.jsx